import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast, Bounce } from 'react-toastify';
import { FaSpinner } from "react-icons/fa";
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import config from '../../config';
import { useAuth } from '../../contexts/AuthContext';
import { getDefaultDashboardRoute } from '../../utils/dashboardNavigation';

const Login = () => {
    const [Username, setUsername] = useState('');
    const [Password, setPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const { login } = useAuth();

    const sleep = ms => new Promise(r => setTimeout(r, ms));

    const isEmpty = value => value == null || (typeof value === "string" && value.trim().length === 0);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (isEmpty(Username) || isEmpty(Password)) {
            toast.error(<p dir="rtl" className="font-custom">لطفا نام کاربری و رمز عبور خود را وارد کنید</p>);
            setIsLoading(false);
            return;
        }

        const data = { Username, Password };

        try {
            const response = await axios.post(`${config.apiBaseUrl}/Login`, data, {
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                    'HeaderKey': config.HeaderKey
                }
            });

            const access = response.data;
            if (access.status === true) {
                const permissions = await login(access.userInfo);

                toast.success(<p dir="rtl" className="font-custom">خوش آمدید.</p>);
                await sleep(1000);
                navigate(getDefaultDashboardRoute(permissions));
            } else {
                toast.error(access.userInfo.message || 'ورود ناموفق بود');
            }

        } catch (error) {
            if (error.response?.status === 401) {
                toast.error(<p dir="rtl" className="font-custom text-xs">نام کاربری و یا رمزعبور وارد شده صحیح نمی‌باشد</p>);

            } else {
                toast.error(<p dir="rtl" className="font-custom">خطایی رخ داد، لطفاً مجدد تلاش کنید.</p>);

            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <section className="bg-gray-100 font-custom dark:bg-gray-900 min-h-screen flex items-center justify-center px-4">
            <div className="w-full max-w-md sm:max-w-sm md:max-w-md bg-white dark:bg-gray-800 shadow-lg rounded-xl p-6 sm:p-8 space-y-6">
                <div className="text-center">
                    <h1 className="text-2xl font-bold text-gray-900 dark:text-white font-custom mb-2">خوش آمدید</h1>
                    <p className="text-sm text-gray-600 dark:text-gray-300">برای شروع، وارد شوید</p>
                </div>
                <form className="space-y-4" onSubmit={handleSubmit}>
                    <input
                        type="text"
                        name="Username"
                        value={Username}
                        onChange={(e) => setUsername(e.target.value)}
                        dir='ltr'
                        placeholder="نام کاربری"
                        className="w-full p-2.5 text-right text-sm rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    />
                    <input
                        type="password"
                        name="Password"
                        value={Password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="رمز عبور"
                        dir='ltr'
                        className="w-full p-2.5 text-right text-sm rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                    />
                    <div className="flex items-center justify-between text-sm">
                        <label className="flex items-center gap-2 text-gray-700 dark:text-gray-300">
                            <input
                                type="checkbox"
                                className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded dark:bg-gray-700 dark:border-gray-600"
                            />
                            مرا به خاطر بسپار
                        </label>
                    </div>
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="w-full flex justify-center items-center gap-2 bg-blue-500 hover:bg-blue-700 text-white font-medium rounded-lg text-sm px-4 py-2.5 transition-colors duration-300 disabled:opacity-70"
                    >
                        {isLoading ? <FaSpinner className="animate-spin" /> : "ورود"}
                    </button>
                </form>
                <ToastContainer
                    position="bottom-center"
                    autoClose={5000}
                    theme="dark"
                    transition={Bounce}
                    rtl
                />
            </div>
        </section>
    );
};

export default Login;
